// Ícono oficial de Tienda Nube — solo el símbolo (la nube), sin el wordmark.
// Usa `currentColor` para tomar el color del texto (className `text-*`), así se
// pinta acorde al estilo ATLAS. Extraído del logo oficial (CC).

import React from "react";

export const TiendaNubeIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    viewBox="0 0 139.2 100"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M89.1 0H89C75.9 0 63.5 5.1 54.2 14.2c-4.7-2-9.9-3.1-15.2-3.1C17.6 11.1.1 28.5.1 50S17.5 88.9 39 88.9c5.2 0 10.4-1.1 15.1-3.1 9 8.8 21.3 14.2 34.8 14.2 27.6 0 50-22.4 50-50 .1-27.5-22.3-50-49.8-50zM89 88.9c-21.4 0-38.9-17.4-38.9-38.9H39c0 9.8 2.8 19 7.7 26.7-2.5.7-5.1 1.1-7.7 1.1-15.3 0-27.8-12.5-27.8-27.8S23.7 22.2 39 22.2c6.1 0 11.8 1.9 16.7 5.6 7.1 5.3 11.1 13.4 11.1 22.2H78c0-11.6-5-22.4-13.9-29.8 7-5.8 15.8-9.1 25-9.1 21.4 0 38.9 17.5 38.9 38.9-.1 21.4-17.5 38.9-39 38.9z" />
  </svg>
);

export default TiendaNubeIcon;

/**
 * El mismo símbolo, dibujado sobre una grilla de 16×16 — la versión que viene de
 * Figma (`nimbus_tiendanube`) para tamaños chicos.
 *
 * Convive con el de arriba en vez de reemplazarlo: `TiendaNubeIcon` se usa en una
 * decena de pantallas con `h-4 w-auto` sobre un viewBox apaisado (139×100), y este
 * es CUADRADO, así que a igual alto ocupa menos ancho y cambiaría el calce en todas.
 * Acá los dos dibujos viven en el mismo archivo a propósito: la divergencia queda a
 * la vista y nadie termina copiando el path por tercera vez.
 *
 * Sin el `clipPath` del export original de Figma: recortaba con un rect del tamaño
 * del viewBox (o sea, no recortaba nada) y su `id` es global al documento — con el
 * ícono montado dos veces (mobile + desktop) habría dos `clip0` iguales en el DOM.
 */
export const TiendaNubeIconCompacto: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    viewBox="0 0 16 16"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M10.25 2.24001C8.75654 2.24808 7.32374 2.83195 6.25 3.87001C5.569 3.58377 4.82778 3.47037 4.09235 3.5399C3.35692 3.60944 2.65009 3.85975 2.03481 4.26856C1.41952 4.67737 0.914877 5.23198 0.565802 5.88301C0.216727 6.53405 0.0340576 7.2613 0.0340576 8.00001C0.0340576 8.73872 0.216727 9.46597 0.565802 10.117C0.914877 10.768 1.41952 11.3227 2.03481 11.7315C2.65009 12.1403 3.35692 12.3906 4.09235 12.4601C4.82778 12.5297 5.569 12.4163 6.25 12.13C6.92718 12.7883 7.75584 13.27 8.66301 13.5327C9.57018 13.7954 10.528 13.831 11.4522 13.6363C12.3763 13.4417 13.2385 13.0228 13.9626 12.4165C14.6868 11.8102 15.2507 11.0352 15.6048 10.1597C15.9589 9.28413 16.0923 8.33495 15.9933 7.39573C15.8942 6.45651 15.5657 5.55605 15.0367 4.77367C14.5077 3.9913 13.7944 3.351 12.9597 2.90917C12.125 2.46734 11.1944 2.23754 10.25 2.24001ZM10.25 12.48C9.06091 12.48 7.92037 12.0083 7.07862 11.1685C6.23687 10.3286 5.76265 9.1891 5.76 8.00001H4.48C4.48001 9.08697 4.78864 10.1516 5.37 11.07C5.08388 11.1529 4.78786 11.1966 4.49 11.2C3.64131 11.2 2.82738 10.8629 2.22726 10.2628C1.62714 9.66264 1.29 8.8487 1.29 8.00001C1.29 7.15132 1.62714 6.33738 2.22726 5.73727C2.82738 5.13715 3.64131 4.80001 4.49 4.80001C5.33869 4.80001 6.15263 5.13715 6.75274 5.73727C7.35286 6.33738 7.69 7.15132 7.69 8.00001H9C9.00027 7.34309 8.85411 6.69436 8.57215 6.10103C8.29019 5.5077 7.87951 4.98467 7.37 4.57001C7.92157 4.10658 8.57676 3.783 9.28002 3.62671C9.98327 3.47042 10.7138 3.48603 11.4098 3.67222C12.1057 3.85841 12.7465 4.20969 13.2778 4.69626C13.809 5.18284 14.2151 5.79035 14.4616 6.46729C14.7081 7.14423 14.7876 7.87063 14.6936 8.58487C14.5995 9.29912 14.3346 9.98015 13.9213 10.5702C13.508 11.1603 12.9585 11.642 12.3194 11.9744C11.6803 12.3069 10.9704 12.4803 10.25 12.48Z" />
  </svg>
);
